import { FC, useState } from 'react';
import { FormLabel, Select } from '@chakra-ui/react';
import { formatNumber } from 'ui/helpers';
import { useFundingSources } from 'hooks';
import { FundingSource, CbFundingSourceSelectorProps } from './types';
import styles from './CbFundingSourceSelector.module.css';
export const CbFundingSourceSelector: FC<CbFundingSourceSelectorProps> = ({
  onFundingSourceSelected
}) => {
  const [fundingSource, setFundingSource] = useState<FundingSource | null>(null);
  const {
    fundingSources
  } = useFundingSources();
  const handleFundingSourceSelected = (fundingSource: FundingSource) => {
    setFundingSource(fundingSource);
    onFundingSourceSelected(fundingSource);
  };
  if (!fundingSources) return null;
  return <div className={styles.fundingSourceSelectWrapper} data-sentry-component="CbFundingSourceSelector" data-sentry-source-file="CbFundingSourceSelector.tsx">
      <FormLabel htmlFor="fundingAccount" marginTop={0} data-sentry-element="FormLabel" data-sentry-source-file="CbFundingSourceSelector.tsx">
        {'Fund from'}
      </FormLabel>
      <Select className={styles.fundingSourceSelect} data-testid={'funding-select'} value={fundingSource?.type} width="md" onChange={e => {
      const selectedFundingSource = fundingSources.find(source => source.type == e.target.value) as FundingSource;
      handleFundingSourceSelected(selectedFundingSource);
    }} data-sentry-element="Select" data-sentry-source-file="CbFundingSourceSelector.tsx">
        <option value="">{'Select a funding source'}</option>
        {!!fundingSources && fundingSources.map((source, i) => <option key={i} value={source.type}>
              {`${source.name} (${source.isStrategicPartner ? 'Unlimited' : formatNumber(source.balance)})`}
            </option>)}
      </Select>
    </div>;
};